import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd/lib/index';
import classnames from 'classnames';
import logo from 'assets/img/oi_novoGuide.png';

const Info = ({ headline, title, subtitle, features }) => {
  return (
    <aside className="w-100 h-100 pa4 overflow-y-auto">
      <section>
        <div>
          <img className="plan-img" src={logo} alt="Oi logo" />
          {headline && <h2 className="plan-invitation-title pt4">{headline}</h2>}
        </div>
        <div className={classnames("plan-info", {"mt5": !headline})}>
          <div className="pb4">
            <p>
              <span className="ttu plan-title">{title}</span>
              <span className={classnames("ttu plan-subtitle db", { "pt4": !title })}>{subtitle}</span>
            </p>
          </div>
          <div>
            {features && features.map((feature, index) => {
              return (
                <div key={index} className="pt3">
                  <Icon type="check" />
                  <span className="plan-features pl2">{feature}</span>
                </div>
              );
            })}
          </div>
          <div className="pt4">
            <div className="info-footer-border"></div>
            <span className="info-footer-title">Já possui um ou mais produtos?</span>
            <span className="info-footer-text db pt2">Fique tranquilo, os seus produtos serão adicionados automaticamente ao combo escolhido.</span>
          </div>
        </div>
      </section>

    </aside>
  );
};

Info.propTypes = {
  headline: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  features: PropTypes.array
};

export default Info;
